import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import {
    ChangePasswordReq,
    ChangeUserTypeReq,
    CreatePartnerAccount,
    CreateUserReq,
    DeleteUserReq,
    LockAccountReqBody,
    LockUserReq,
    ResetUserPassword,
    SearchUser,
    SearchUserReq,
    UpdateAccount,
    UpdateUserReq,
    UserDetail,
} from '@models/user.model';
import { BaseResponseModel, ResponseModel } from '@models/app.model';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    pipe(arg0: any, arg1: any, arg2: any) {
        throw new Error('Method not implemented.');
    }
    constructor(private httpService: HttpService) {}

    public lockAccount(reqBody: LockAccountReqBody): Observable<ResponseModel> {
        return this.httpService.post('User/Lock', reqBody);
    }

    /**
     * Search user by param
     *
     * @param {SearchUserReq} reqParam
     * @return {*}  {Observable<SearchUser[]>}
     * @memberof UserService
     */
    public searchListUser(reqParam: SearchUserReq): Observable<BaseResponseModel<SearchUser[]>> {
        return this.httpService.get('User/SearchListUser', {
            params: new HttpParams({
                fromObject: {
                    ...reqParam,
                },
            }),
        });
    }

    /**
     * Get detail user
     *
     * @param {string} userId
     * @return {*}  {Observable<UserDetail>}
     * @memberof UserService
     */
    public getUserByUserId(userId: string): Observable<UserDetail> {
        return this.httpService.get('User/GetDetail', {
            params: new HttpParams({
                fromObject: {
                    userId,
                },
            }),
        });
    }

    /**
     * Reset password user
     *
     * @param {ResetUserPassword} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public resetPassword(reqBody: ResetUserPassword): Observable<ResponseModel> {
        return this.httpService.post('User/ResetPassword', reqBody);
    }

    /**
     * Create new user
     *
     * @param {CreateUserReq} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public create(reqBody: CreateUserReq): Observable<ResponseModel> {
        return this.httpService.post('User/Create', reqBody);
    }

    /**
     * Update user
     *
     * @param {UpdateUserReq} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public update(reqBody: UpdateUserReq): Observable<ResponseModel> {
        return this.httpService.post('User/Update', reqBody);
    }

    /**
     * Lock/unlock user
     *
     * @param {LockUserReq} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public lock(reqBody: LockUserReq): Observable<ResponseModel> {
        return this.httpService.post('User/Lock', reqBody);
    }

    /**
     * Delete user
     *
     * @param {DeleteUserReq} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public deleteAccount(reqBody: DeleteUserReq): Observable<ResponseModel> {
        return this.httpService.post('User/DeleteByManage', reqBody);
    }

    /**
     * Change password user
     *
     * @param {ChangePasswordReq} reqBody
     * @return {*}  {Observable<ResponseModel>}
     * @memberof UserService
     */
    public changePassword(reqBody: ChangePasswordReq): Observable<ResponseModel> {
        return this.httpService.post('User/ChangePassword', reqBody);
    }

    public changeUserType(reqBody: ChangeUserTypeReq): Observable<ResponseModel> {
        return this.httpService.post('User/UpdateUserType', reqBody);
    }

    public updateAccount(reqBody: any): Observable<ResponseModel> {
        return this.httpService.post('User/UpdateProfileUser', reqBody)
    }

    public createPartnerAccount(reqBody: CreatePartnerAccount): Observable<ResponseModel> {
        return this.httpService.post('User/Create', reqBody);
    }

    public updatePartnerAccount(reqBody: UpdateAccount): Observable<ResponseModel> {
        return this.httpService.post('User/Update', reqBody);
    }
}
